import { useEffect, useState } from 'react';
import { getLanguageSettings, updateLanguageSettings } from '../../services/api';

export default function LanguagesPage() {
  const [text, setText] = useState('');
  const [version, setVersion] = useState<number | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const load = async () => {
    setBusy(true); setError(''); setSaved(false);
    try {
      const data = await getLanguageSettings();
      setText(data.languages.join('\n')); setVersion(data.version);
    } catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  };
  useEffect(() => { void load(); }, []);
  const save = async () => {
    if (version === null) return;
    const languages = text.split('\n').map(s => s.trim()).filter(Boolean);
    if (!languages.length || languages.length > 200 || languages.some(s => s.length > 80 || /^(other|others)$/i.test(s)) || new Set(languages.map(s => s.toLowerCase())).size !== languages.length) {
      setError('Enter 1–200 unique names, up to 80 characters each. Other/Others is reserved.'); return;
    }
    setBusy(true); setError(''); setSaved(false);
    try {
      const data = await updateLanguageSettings({ languages, version });
      setVersion(data.version); setText(data.languages.join('\n')); setSaved(true);
    } catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  };
  return <div className="max-w-2xl mx-auto p-6 space-y-4">
    <h1 className="text-2xl font-semibold">Submission Languages</h1>
    <p className="text-gray-600">Enter one language per line, in dropdown order. Updated apps fetch this list when enumerators open a new submission. Offline devices use their last saved list. Existing submissions keep their language.</p>
    <label className="block font-medium" htmlFor="languages">Languages</label>
    <textarea id="languages" rows={16} className="input w-full font-mono" value={text} disabled={busy || version === null} onChange={e => { setText(e.target.value); setSaved(false); }} />
    <p className="text-sm text-gray-500">The app also offers Others for languages not listed here. Project forms with a language field use this list too.</p>
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {saved && <p role="status" className="text-green-700">Language list saved.</p>}
    <div className="flex gap-3">
      <button className="btn-primary" disabled={busy || version === null} onClick={save}>{busy ? 'Please wait…' : 'Save languages'}</button>
      <button className="btn-secondary" disabled={busy} onClick={load}>Reload saved list</button>
    </div>
  </div>;
}
